import React, { useEffect, useState, useCallback } from "react";
// Dropdown option models are not required at runtime here
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { getStorageValues } from "../../shared/CommonFunctions.jsx";
import { getApiBaseUrl } from "../../utils/apiConfig.js";
function EditUser({ UserData, sendDataToParent }) {
  const [companyOptions, setCompanyOptions] = useState([]);
  const [userModuleOptions, setUserModuleOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedModuleOption, setSelectedModuleOption] = useState(null);
  const [roleChanged, setRoleChanged] = useState(false);
  const [moduleChanged, setModuleChanged] = useState(false);
  const [getPhoneNumber, setPhoneNumber] = useState("");
  const groupStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  };

  const groupBadgeStyles = {
    backgroundColor: "#EBECF0",
    borderRadius: "2em",
    color: "#172B4D",
    display: "inline-block",
    fontSize: 12,
    fontWeight: "normal",
    lineHeight: "1",
    minWidth: 1,
    padding: "0.16666666666667em 0.5em",
    textAlign: "center",
  };

  const formatGroupLabel = (data) => (
    <div className="GroupStyles" style={groupStyles}>
      <span>{data.label}</span>
      <span className="GroupBadgeStyles" style={groupBadgeStyles}>
        {data.options.length}
      </span>
    </div>
  );

  function handleChange(e) {
    const { name, value } = e.currentTarget;

    if (name === "PhoneNumber") {
      if (/^\d*$/.test(value)) {
        setPhoneNumber(value);
      }
      return; 
    }

    sendDataToParent((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }

  function handleRoleChange(e) {
    setSelectedOption(e);
    if (e && e.value) fetchUserModules(e.value);
    setRoleChanged(true);
    if (e !== null) {
      sendDataToParent((prevState) => ({
        ...prevState,
        CompanyId: e.groupId,
        RoleId: e.value,
      }));
    } else {
      sendDataToParent((prevState) => ({
        ...prevState,
        CompanyId: null,
        RoleId: null,
      }));
    }
  }
  function handleUserModuleChange(e) {
    setSelectedModuleOption(e);
    setModuleChanged(true);
    if (e !== null) {
      sendDataToParent((prevState) => ({
        ...prevState,
        DefaultModuleId: e.value,
      }));
    } else {
      sendDataToParent((prevState) => ({
        ...prevState,
        DefaultModuleId: null,
      }));
    }
  }
  function setCompanyRolesDropdownData(cr) {
    var groupOpt = cr
      .map((x) => ({ id: x.CompanyId, label: x.CompanyName, options: null }))
      .filter(
        (value, index, self) =>
          self.findIndex((m) => m.id === value.id) === index
      );
    let allRoleOpt = [];
    groupOpt.forEach((e) => {
      let rlOpt = cr.filter((x) => x.CompanyId === e.id);
      let roleOpt = rlOpt.map((p) => ({
        value: p.RoleId,
        label: p.RoleName,
        name: p.RoleName,
        description: "",
        isFixed: false,
        isDisabled: false,
        groupId: e.id,
      }));
      allRoleOpt.push(roleOpt);
      e.options = roleOpt;
    });
    // setRoleOptions(allRoleOpt);
    setCompanyOptions(groupOpt);
  }
  function setUserModuleDropdownData(um) {
    let allModuleOpt = [];
    allModuleOpt = um.map((p) => ({
      value: p.ModuleId,
      label: p.ParentModuleName + " -> " + p.Name,
      name: p.ParentModuleName + " -> " + p.Name,
      description: "",
      isFixed: false,
      isDisabled: false,
      groupId: null,
    }));
    setUserModuleOptions(allModuleOpt);
  }

  // When companyOptions and UserData are available, set the selected role
  useEffect(() => {
    if (companyOptions && companyOptions.length > 0 && UserData && UserData.RoleId && !roleChanged) {
      const allRoles = companyOptions.flatMap((g) => g.options || []);
      const found = allRoles.find((r) => r.value === UserData.RoleId) || null;
      setSelectedOption(found);
    }
  }, [companyOptions, UserData, roleChanged]);

  // When userModuleOptions and UserData are available, set the selected module
  useEffect(() => {
    if (userModuleOptions && userModuleOptions.length > 0 && UserData && UserData.DefaultModuleId && !moduleChanged) {
      const found = userModuleOptions.find((m) => m.value === UserData.DefaultModuleId) || null;
      setSelectedModuleOption(found);
    }
  }, [userModuleOptions, UserData, moduleChanged]);
  const fetchCompanyRoles = useCallback(async () => {
    try {
      const response = await axios.get(`${getApiBaseUrl()}/getrolesbycompany`, {
        params: { CompanyId: process.env.REACT_APP_COMPANY_ID },
      });
      if (response.status === 200) {
        setCompanyRolesDropdownData(response.data.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchUserModules = useCallback(async (roleId) => {
    try {
      const response = await axios.get(
        getApiBaseUrl() +
          "/usermodulesfdd?UserId=" +
          getStorageValues("userId") +
          "&RoleId=" +
          roleId
      );
      if (response.status === 200) {
        setUserModuleDropdownData(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);
  const roleId = UserData ? UserData.RoleId : null;

  useEffect(() => {
    fetchCompanyRoles();
    if (roleId) {
      fetchUserModules(roleId);
    }
  }, [roleId, fetchCompanyRoles, fetchUserModules]);

  return (
    <>
      <div className="row">
        <div className="mb-3">
          <label className="form-label">
            Full Name <span style={{ color: "red" }}>*</span>
          </label>
          <input type="hidden" name="Id" value={UserData.Id ?? ""} />
          <input
            type="text"
            className="form-control"
            name="FullName"
            value={UserData.FullName ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">
            Email <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="Email"
            value={UserData.Email ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Mobile No </label>
          <input
            type="text"
            className="form-control"
            name="PhoneNumber"
            value={getPhoneNumber || UserData.PhoneNumber !== null || UserData.PhoneNumber !== undefined ? UserData.PhoneNumber : ""}
            onChange={handleChange}
            maxLength="10"
          />
        </div>
        <div className="mb-3">
          <label className="form-label">
            UserName <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="UserName"
            value={UserData.UserName ?? ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-12">
          <div className="mb-3">
            <label className="form-label">
              Select Role <span style={{ color: "red" }}>*</span>
            </label>
            <Select
              name="RoleId"
              value={selectedOption ?? []}
              isClearable={true}
              options={companyOptions || []}
              formatGroupLabel={formatGroupLabel}
              onChange={(e) => handleRoleChange(e)}
            />
          </div>
        </div>
        <div className="col-12">
          <div className="mb-3">
            <label className="form-label">Select Default Module</label>
            <Select
              name="ModuleId"
              value={selectedModuleOption ? selectedModuleOption : []}
              isClearable={true}
              options={userModuleOptions || []}
              onChange={(e) => handleUserModuleChange(e)}
            />
          </div>
        </div>
        {/* <div className="col-lg-4 col-sm-6 col-12">
          <div className="mb-3">
            <label className="form-label">Select Date </label>
            <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} />
          </div>
        </div> */}
      </div>
    </>
  );
}

export default EditUser;
